import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getConsent, setConsent } from "../lib/consent";

export const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (!getConsent()) setVisible(true);
    const reopen = () => setVisible(true);
    window.addEventListener("briouse:cookie-settings", reopen);
    return () => window.removeEventListener("briouse:cookie-settings", reopen);
  }, []);

  if (!visible || location.pathname.startsWith("/extranet")) return null;

  const choose = (ok) => {
    setConsent(ok);
    setVisible(false);
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-[70] p-3 sm:p-4" role="dialog" aria-label="Gestion des cookies" data-testid="cookie-banner">
      <div className="mx-auto max-w-3xl bg-white border border-pierre shadow-xl rounded-xl p-4 sm:p-5">
        <p className="text-sm text-ardoise leading-relaxed">
          <strong className="font-serif text-domaine">Cookies & mesure d'audience.</strong>{" "}
          Avec votre accord, nous utilisons Google Analytics pour mesurer l'audience du site et améliorer votre expérience.
          Aucun cookie de mesure n'est déposé sans votre consentement, valable 6 mois et modifiable à tout moment via
          « Gérer les cookies » en bas de page.{" "}
          <Link to="/politique-de-confidentialite" className="underline hover:text-domaine" data-testid="cookie-banner-privacy-link">
            En savoir plus
          </Link>
        </p>
        <div className="mt-4 flex flex-col sm:flex-row gap-2 sm:justify-end">
          <button onClick={() => choose(false)}
                  className="px-5 py-2.5 text-sm border border-ardoise/40 text-ardoise rounded-md hover:bg-ardoise/5"
                  data-testid="cookie-refuse-btn">
            Tout refuser
          </button>
          <button onClick={() => choose(true)}
                  className="px-5 py-2.5 text-sm bg-domaine text-white rounded-md hover:opacity-90"
                  data-testid="cookie-accept-btn">
            Tout accepter
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
